import Graph from '../Graph'
import { Point } from 'Vectorgraph/Point'
import { getBorderBreaks, setSectionTo } from 'Vectorgraph'
import { STSGraph } from './STS'
import { useSettings } from 'Settings'
import ValueTransform from 'ValueTransform'

const getBorderBreakInSection = (graph, from, to, border, top) => {
	const breaks = getBorderBreaks(graph, border, top)

	return breaks.find((p) => p[0] >= from && p[0] <= to)
}

const HrvLow = (props) => {
	const [settings] = useSettings()
	const acc = settings['supervisory level']['v_lvl_acc'].value
	const v_bat_max_lo = ValueTransform(settings['supervisory level']['v_bat_max_lo'].value, acc)

	let graph = []
	const sts = STSGraph()

	graph.push(Point(0, 0))
	graph.push(Point(9, 0))

	graph = setSectionTo(graph, 3, 4, 1)

	const bb = getBorderBreakInSection(sts, 7, 8, v_bat_max_lo, false)
	graph = setSectionTo(graph, bb[0], 8, 1)

	return (
		<Graph {...props} points={graph} />
	)
}

export default HrvLow
